import { ISetup } from "@smartrr/shared/entities/Organization";
import { GettingStartedStep } from "../GettingStartedStep";

export class SubscriptionProgramStep extends GettingStartedStep {
  getOrder(): number {
    return 2;
  }

  protected deriveCompleted(setup: ISetup): boolean {
    return Boolean(
      setup.subscriptionSetup?.product?.completed && setup.subscriptionSetup?.sellingPlan?.completed
    );
  }
}
